import { useStation } from '../../../../../../../core/stations/hooks/useStation';
import { isExternalExportEnabledV1 } from '../../../../../hooks/isExternalExportEnabled';
import { useFragmentCtx } from '../../../context/fragment-ctx';
import { ExternalExportStatusV1 } from './v1-old/ExternalExportStatusV1';
import { FragmentDeliveryStatus } from './v2-fragments-delivery/FragmentDeliveryStatus';

export const ExternalExportStatus = () => {
  const fragment = useFragmentCtx();

  const externalExportEnabledV1 = isExternalExportEnabledV1(useStation(fragment.stationId));

  if (externalExportEnabledV1) {
    return <ExternalExportStatusV1 />;
  }

  return <FragmentDeliveryStatus />;
};
